import { BaseRouteService } from 'core/services';

class FacilityRouteService extends BaseRouteService {
    constructor() {
        super('facilities');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,isOnHold,inActive,accountRepId,corporateId,stateId,address,emr,emrUserName,emrPassword,isNiko,nikoPatientId,itemCategoryId,dosDateFrom,dosDateTo,billingValidation}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }

    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    sync(){
        return super.update(this.base + '/sync');
    }

    syncNiko() {
        return super.update(this.base + '/sync-niko');
    }

    download(filter) {
        return super.find(this.base + '/download/{?searchQuery,sort,inActive,accountRepId,corporateId,address,isNiko}', filter);    
    }
  
    downloadESign(filter) {
        return super.find(this.base + '/download-esign/{?searchQuery,sort,inActive,accountRepId,corporateId,address,isNiko}', filter);    
    }

    downloadContacts(filter) {
        return super.find(this.base + '/download-contacts/{?searchQuery,sort,inActive,accountRepId,corporateId,address,contactDepartmentIds,isNiko}', filter);    
    }

    upload(resource){
        return super.create(this.base + '/upload', resource);
    }

    bulkUpdate(resource) {
        return super.update(this.base + '/batch', resource);
    }

    updatePumpsNote(resource) {
		return super.update(`${this.base}/update-pumps-note`, resource);	
	}

    syncAddress(resource) {
		return super.update(`${this.base}/sync-address/{id}`, resource);
	}

    hasNikoDeliveryLocation(id) {
        return super.get(`${this.base}/{id}/has-niko-delivery-location`, id, null);
    }

    syncAndValidatePayers(id) {
        return super.update(`${this.base}/{id}/payers/sync-and-validate`, { id });
    }
}

export default FacilityRouteService;
